import type {SVGProps} from 'react';

export const CircleHelpIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            {...props}
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z'/>
            <path d='M10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5Z'/>
            <path d='M11 13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V12.9269C13.5554 12.8399 14.1209 12.6629 14.6172 12.3321C15.4919 11.7489 16 10.7913 16 9.5C16 8.36777 15.5866 7.44027 14.8937 6.79278C14.2176 6.16099 13.3395 5.85432 12.4851 5.81363C10.8171 5.73421 8.86961 6.69961 8.51361 8.8356C8.42281 9.38037 8.79083 9.8956 9.3356 9.9864C9.88037 10.0772 10.3956 9.70917 10.4864 9.1644C10.6304 8.3004 11.4329 7.7658 12.3899 7.81137C12.848 7.83318 13.2512 7.99526 13.5282 8.2541C13.7884 8.49723 14 8.88224 14 9.5C14 10.2087 13.7581 10.5011 13.5078 10.668C13.1859 10.8825 12.6705 11 12 11C11.4477 11 11 11.4477 11 12V13Z' />
        </svg>
    );
};
